import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';

import { SessionTranscriptResponse } from 'features/sessions/config/types';

export const useSessionTranscriptQuery = (isEnabled: boolean) => {
  const { sessionId } = useParams();
  const { request } = useQueryHTTPRequest();

  return useQuery<SessionTranscriptResponse, unknown, string>(
    [queryKeys.coachSessionTranscript, sessionId],
    () =>
      request({ url: `/api/coach/coaching-sessions/${sessionId}/transcript` }),
    {
      enabled: !!sessionId && isEnabled,
      select: (data) => data.transcript.replace(/\n/g, '\n'),
      useErrorBoundary: false,
    }
  );
};
